import { AlcoholInteraction, Interaction, MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { MedicineAlcoholIndicatorConfig, MedicineSafetyIndicatorConfig, MedicineSafetyIndicatorType } from '../types';

const createMedicineSafetyConfig = (interaction: Interaction | undefined): MedicineSafetyIndicatorConfig => {
   if (!interaction?.status || interaction.status === 'UNKNOWN') {
      return {
         status: 'UNKNOWN',
         comment: interaction?.name,
      };
   }
   if (interaction.status === 'SAFE') {
      return {
         status: 'SAFE',
      };
   }
   return {
      status: interaction.status,
      comment: interaction.name,
   };
};

const createMedicineAlcoholSafetyConfig = (
   interaction: AlcoholInteraction | undefined
): MedicineAlcoholIndicatorConfig => {
   if (!interaction?.status || interaction?.status === 'UNKNOWN') {
      return {
         status: 'UNKNOWN',
         comment: interaction?.observationDescription,
      };
   }
   if (interaction.status === 'SAFE') {
      return {
         status: 'SAFE',
      };
   }
   if (interaction.status === 'UNSAFE') {
      return {
         status: interaction.status,
         comment: interaction.observationDescription!,
         interactionTarget: interaction.organsInfluenceDescription!,
      };
   }
   return {
      status: 'AMBIGUOUS',
      comment: interaction.observationDescription,
   };
};

export const mapMedicineSimpleToMedicineSafetyIndicatorsConfig = (
   medicineSimple: MedicineSimple
): Record<Exclude<MedicineSafetyIndicatorType, 'interactionWithAlcohol'>, MedicineSafetyIndicatorConfig> &
   Record<'interactionWithAlcohol', MedicineAlcoholIndicatorConfig> => {
   return {
      drivingCar: createMedicineSafetyConfig(medicineSimple.drivingInteraction),
      interactionWithAlcohol: createMedicineAlcoholSafetyConfig(medicineSimple.alcoholInteraction),
      breastFeeding: createMedicineSafetyConfig(medicineSimple.lactationInteraction),
      pregnantFirstTrimester: createMedicineSafetyConfig(medicineSimple.firstTrimesterInteraction),
      pregnantSecondTrimester: createMedicineSafetyConfig(medicineSimple.secondTrimesterInteraction),
      pregnantThirdTrimester: createMedicineSafetyConfig(medicineSimple.thirdTrimesterInteraction),
   };
};
